// src/components/FloatingWhatsApp.jsx
import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingWhatsApp = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      // href={`https://wa.me/9420085453`}
      // href={`https://wa.me/9004910709`}
      href="https://wa.me/919004910709"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      style={styles.button(hovered)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered && <span style={styles.tooltip}>Chat with us!</span>}
      <FaWhatsapp size={28} color="white" />
    </a>
  );
};

const styles = {
  button: (hovered) => ({
    position: 'fixed',
    bottom: 28,
    right: 28,
    backgroundColor: '#25D366',
    borderRadius: '50%',
    width: 58,
    height: 58,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    boxShadow: hovered
      ? '0 8px 28px rgba(37,211,102,0.5)'
      : '0 4px 16px rgba(37,211,102,0.35)',
    transform: hovered ? 'scale(1.1)' : 'scale(1)',
    transition: 'all 0.25s ease',
    textDecoration: 'none',
  }),
  tooltip: {
    position: 'absolute',
    right: 68,
    backgroundColor: '#1B3F6E',
    color: '#fff',
    padding: '6px 14px',
    borderRadius: 50,
    fontSize: 13,
    fontFamily: "'Lato', sans-serif",
    fontWeight: 600,
    whiteSpace: 'nowrap',
    boxShadow: '0 4px 12px rgba(27,63,110,0.25)',
  },
};

export default FloatingWhatsApp;
